import { render, staticRenderFns } from "./F3Settings.vue?vue&type=template&id=5b7b7ec3"
import script from "./F3Settings.vue?vue&type=script&lang=ts"
export * from "./F3Settings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b7b7ec3')) {
      api.createRecord('5b7b7ec3', component.options)
    } else {
      api.reload('5b7b7ec3', component.options)
    }
    module.hot.accept("./F3Settings.vue?vue&type=template&id=5b7b7ec3", function () {
      api.rerender('5b7b7ec3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/browse/F3Settings.vue"
export default component.exports